
import React, { useState } from "react";
import pluswhite from "assets/images/icon/plus-white.png";
import filtersearch from "assets/images/icon/filter-search.png";
import arrowleft from "assets/images/icon/arrow-left.png";
import arrowright from "assets/images/icon/arrow-right.png";
import Table from "./Table";
import Input from "components/Input";
import AddDepartmentModal from "pages/AddDepartmentModal";
const headers = [
    { headerName: "Department Name", key: "departmentName" },
    { headerName: "Workplace", key: "workplace" },
    { headerName: "Active Status", key: "active_status" },
    { headerName: "", key: "action" },
];

const data = [
    {
        departmentName: "Demo Smith",
        workplace: '32 StreetUS',
        active_status: "Active",
    },
    {
        departmentName: "Demo Smith",
        workplace: '32 StreetUS',
        active_status: "Active",
    }, {
        departmentName: "Demo Smith",
        workplace: '32 StreetUS',
        active_status: "Active",
    },
]
const ManageDepartments = () => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <div>
                <div className='d-flex justify-content-between align-content-end border-bottom  pb-4'>
                    <div>
                        <h2 className='sub-title'>Manage Departments</h2>
                        <button
                            className='button-orange py-2 mt-3 rounded-pill d-flex justify-content-center align-items-center gap-2'
                            onClick={() => setIsOpen(true)}
                        >
                            <img src={pluswhite} alt="pluswhite" />
                            Add Department</button>
                    </div>
                    <div className='align-content-end'>
                        <Input
                            placeholder='Search by Name, Email, or Id'
                            startIcon={filtersearch}
                            style={{
                                width: '300px'
                            }}
                        />
                    </div>
                </div>
                <div>
                    <Table headers={headers} data={data} />

                    <div>
                        <nav aria-label="Page navigation example">
                            <ul className="pagination align-items-center justify-content-end">
                                <div className='border-gray py-2 rounded-3 d-flex align-items-center justify-content-end'>
                                    <li className="page-item">
                                        <a className="page-link" href="#" aria-label="Previous">
                                            <img className='ms-2' src={arrowleft} alt="arrowleft" />
                                        </a>
                                    </li>
                                    <li className="page-item active"><a className="page-link" href="#">1</a></li>
                                    <li className="page-item"><a className="page-link" href="#">2</a></li>
                                    <li className="page-item">
                                        <a className="page-link" href="#" aria-label="Next">
                                            <img className='ms-2' src={arrowright} alt="arrowright" />
                                        </a>
                                    </li>
                                </div>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <AddDepartmentModal
                open={isOpen}
                onClose={() => setIsOpen(false)}
            />
        </>
    )

}

export default ManageDepartments;